export default __webpack_public_path__ + "static/media/clear-correct-logo.c2518135.svg";